import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import moment from "moment";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import RSSB_LOGO from "../assets/RSSB_LOGO.jpeg";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ConfirmationLetterPreview = () => {
  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const letterId = state?.letterId || searchParams.get('letterId');
  const token = localStorage.getItem("token");
  const centerCode = localStorage.getItem("code");

  const [previewData, setPreviewData] = useState(null);
  const [profileDetails, setProfileDetails] = useState(null);
  const email = localStorage.getItem('email')
  const [data, setData] = useState([])
  const navigate = useNavigate();
  const footer = 'H.O. Dera Baba Jaimal Singh, Beas, Distt. Amritsar, Punjab 143 204, India';
  useEffect(() => {
    if (!token) {
      navigate(
        `/?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}&type=challan`
      );


      return;
    }
    const fetchCenterInfo = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/centerInfoForDC`, {
          params: { code: centerCode },
          headers: { 'Authorization': `Bearer ${token}` },
        });

        const center = response.data[0];
        setData(center);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };


    fetchCenterInfo();
  }, []);
  /* ---------------- INLINE PRINT CSS ---------------- */
  const organization = {
    name: data?.centerName,
    addressLine1: data?.addressLine1,
    addressLine2: data?.addressLine2,
    addressLine3: data?.addressLine3,
    mobile1: data?.mobile1,
    mobile2: data?.mobile2,
    gstin: data?.gstin,
    contactPerson1: data?.contactPerson1,
    contactPerson2: data?.contactPerson2,
    position1: data?.position1,
    position2: data?.position2
  };
  const printStyles = `
    @media print {
      @page {
        size: A4;
        margin: 12mm;
      }

      body {
        margin: 0;
        padding: 0;
        background: #fff;
      }

      .print-wrapper {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      table {
        width: 100% !important;
        table-layout: fixed;
        border-collapse: collapse;
      }
      
      th, td {
        font-size: 11px !important;
        padding: 4px !important;
        vertical-align: middle !important;
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
        white-space: normal !important;
      }
    
      th {
        font-weight: 600;
      }

      tr {
        page-break-inside: avoid;
      }
    
      table {
        page-break-after: auto;
      }
      .no-print {
        display: none !important;
      }
      .text-center {
        text-align: center !important;
      }
      
      .text-start {
        text-align: left !important;
      }
      
      .text-end {
        text-align: right !important;
      }
      .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        text-align: center;
        border-top: 1px solid black;
        padding-top: 10px;
        font-weight: bolder;
        font-size: 14px;
      }
      div {
        page-break-inside: avoid;
      }
    }
      
    }
  `;

  const deriveMrAndProjects = (mrIds = [], mrOptions = []) => {
    const projectMap = new Map();
    const mrNos = [];

    mrOptions.forEach(mr => {
      if (mrIds.includes(mr.value)) {
        if (mr.raw.mrNo) mrNos.push(mr.raw.mrNo);

        const key = mr.raw.projectId || mr.raw.projectName;
        if (!projectMap.has(key)) {
          projectMap.set(key, {
            projectName: mr.raw.projectName,
            description: mr.raw.description || "",
            centerName: mr.raw.centerName || "",
          });
        }
      }
    });

    return {
      mrNos,
      projects: Array.from(projectMap.values()),
    };
  };

  
  const handleDownloadPDF = async () => {
    const element = document.getElementById("confirmation-letter-pdf");
    if (!element) return;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(`Confirmation_Letter_${previewData?.refNo}.pdf`);
  };
  const aggregateItemsByItemId = (items = []) => {
    const map = new Map();
  
    items.forEach(item => {
      const key = item.itemId;
  
      if (!map.has(key)) {
        map.set(key, {
          ...item,
          primaryQty: Number(item.primaryQty) || 0,
          secondaryQty: Number(item.secondaryQty) || 0,
        });
      } else {
        const existing = map.get(key);
        existing.primaryQty += Number(item.primaryQty) || 0;
        existing.secondaryQty += Number(item.secondaryQty) || 0;
      }
    });
  
    return Array.from(map.values());
  };

  const groupReceiptsBySupplierAndInvoice = (receipts = []) => {
    const supplierMap = new Map();
  
    receipts.forEach(r => {
      const supplierKey = r.supplier;
      const invoiceKey = `${r.invoiceNo}__${r.invoiceDate}`;
  
      if (!supplierMap.has(supplierKey)) {
        supplierMap.set(supplierKey, {
          supplier: supplierKey,
          invoices: new Map(),
        });
      }
  
      const supplierGroup = supplierMap.get(supplierKey);
  
      if (!supplierGroup.invoices.has(invoiceKey)) {
        supplierGroup.invoices.set(invoiceKey, {
          ...r,
          items: [...r.items],
          mrNos: [...(r.mrNos || [])],
          projects: [...(r.projects || [])],
        });
      } else {
        const invoiceGroup = supplierGroup.invoices.get(invoiceKey);
  
        invoiceGroup.items.push(...r.items);
        invoiceGroup.amount =
          (Number(invoiceGroup.amount) || 0) + (Number(r.amount) || 0);
  
        invoiceGroup.mrNos = Array.from(
          new Set([...(invoiceGroup.mrNos || []), ...(r.mrNos || [])])
        );
  
        const projectMap = new Map();
        [...invoiceGroup.projects, ...(r.projects || [])].forEach(p => {
          projectMap.set(p.projectName, p);
        });
        invoiceGroup.projects = Array.from(projectMap.values());
      }
    });
  
    // convert maps to arrays
    return Array.from(supplierMap.values()).map(s => ({
      supplier: s.supplier,
      invoices: Array.from(s.invoices.values()),
    }));
  };
  
  
  useEffect(() => {
    if (!letterId) return;

    const fetchAll = async () => {
      try {
        const [letterRes, receiptRes, mrRes] = await Promise.all([
          apiClient.get(
            `${SERVER_BASE}/confirmation-letter/${letterId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          ),
          apiClient.get(
            `${SERVER_BASE}/getReceiptVouchers/${centerCode}`
          ),
          apiClient.get(
            `${SERVER_BASE}/get-mrs`,
            { headers: { Authorization: `Bearer ${token}` } }
          )
        ]);

        const letter = letterRes.data;
        const receipts = receiptRes.data || [];
        const mrOptions = mrRes.data.data.map(mr => ({
          value: mr.id,
          raw: mr
        }));

        const hydrated = {
          ...letter,
          receipts: letter.receipts.map(r => {
            const rv = receipts.find(v => v.id === r.receiptId);
            const derived = deriveMrAndProjects(r.mrIds, mrOptions);
        
            return {
              ...r,
        
              // ✅ AGGREGATE HERE
              items: aggregateItemsByItemId(r.items),
        
              supplier: rv?.ledgerName || "",
              invoiceNo: rv?.documentNo || "",
              invoiceDate: rv?.documentDate || "",
              mrNos: derived.mrNos,
              projects: derived.projects
            };
          })
        };
        
        

        const groupedReceipts =
  groupReceiptsBySupplierAndInvoice(hydrated.receipts);

setPreviewData({
  ...hydrated,
  receipts: groupedReceipts,
});

        
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Failed to load preview", "error");
      }
    };

    fetchAll();
  }, [letterId]);

  if (!previewData) return null;

  let srNo = 1;
 
  const getRefYear = () => {
    if (previewData?.letterDate) {
      return moment(previewData?.letterDate)?.year();
    }
    return moment().year();
  };
  
  const REF_PREFIX = `F.66.G Stores/RSSB/JP/RJ/${getRefYear()}/`;

  return (
    <div id='confirmation-letter-pdf' style={{ margin: 'auto', padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '1150px', fontSize: '14px' }}>
      {/* INLINE PRINT STYLE */}
      <style>{printStyles}</style>
      <div className="d-flex justify-content-between">
      <button
          className="btn btn-secondary btn-sm mb-3 no-print"
          onClick={() => { navigate('../dashboard/ConfirmationLetterList') }}
        >
          Back
        </button>

        <button
         className="btn btn-secondary btn-sm mb-3 no-print"
          onClick={() => window.print()}
        >
           Print
        </button>

        </div>
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-start  pb-2 mb-2" style={{borderBottom:'1px solid '}}>
          {/* Left side: Logo and organization details */}
          <div className="d-flex align-items-start">
            <img src={RSSB_LOGO} alt="Logo" className="me-3" style={{ height: '75px' }} />
            <div className="text-start">
              <h6 className="mb-0">{organization?.name}</h6>
              {/* <p className="mb-0">{organization?.addressLine1}</p> */}
              <p className="mb-0">{organization?.addressLine2}</p>
              <p className="mb-0">{organization?.addressLine3}</p>
              <p className="mb-0">TELEPHONE: +91-{organization?.mobile1}</p>
            </div>
          </div>

          {/* Right side: Receiving department, request number, and date */}
          <div className="text-end mt-2" style={{ fontSize: '14px' }}>
            <h6 className="mb-0 fw-bold">{organization?.contactPerson1}</h6>
            <p className="mb-0">{organization?.position1}</p>
          </div>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <div>
            <strong>Ref. No.:</strong> {REF_PREFIX}{previewData.refNo}
          </div>
          <div>
            <strong>Dated:</strong>{" "}
            {previewData.letterDate
              ? moment(previewData.letterDate).format("DD-MM-YYYY")
              : ""}
          </div>
        </div>

        {/* ADDRESS */}
        <div style={{ whiteSpace: "pre-line" }} className="mb-3">
          {previewData.addressText}
        </div>

        {/* SUBJECT */}
        <div className="mb-2">
          <strong>Sub.: {previewData.subject}</strong> 
        </div>

        {/* DEAR */}
        <div className="mb-2">{previewData.dearLine}</div>

        {/* BODY */}
        <div className="mb-3" style={{ whiteSpace: "pre-line" }}>
          {previewData.bodyText}
        </div>

        {/* TABLE */}
        <table className="table table-bordered text-center align-middle" style={{border:'1px solid'}}>
          <thead className="text-center align-middle">
            <tr>
              <th style={{ width: "4%" }}>#</th>
              <th style={{ width: "13%" }}>Supplier Name</th>
              <th style={{ width: "12%" }}>Invoice & Date</th>
              <th style={{ width: "9%" }}>Amount in Rs</th>
              <th style={{ width: "9%" }}>HSN</th>
              <th style={{ width: "7%" }}>Item Code</th>
              <th style={{ width: "14%" }}>Item</th>
              <th colSpan={2} style={{ width: "13%" }}>Billed. Qty</th>
             
              <th style={{ width: "10%" }}>Breakage <br />Shortage <br />Quality</th>
              <th style={{ width: "17%" }}>Project# <br /> Order#</th>
            </tr>
          </thead>

         <tbody>
  {previewData.receipts.map(supplier =>
    supplier.invoices.map((r, invoiceIdx) =>
      r.items.map((item, itemIdx) => (
        <tr key={`${supplier.supplier}-${invoiceIdx}-${itemIdx}`}>
          <td>{srNo++}</td>

          {/* SUPPLIER – only once */}
          {invoiceIdx === 0 && itemIdx === 0 && (
            <td
              rowSpan={supplier.invoices.reduce(
                (sum, inv) => sum + inv.items.length,
                0
              )}
              className="fw-bold"
              style={{fontSize:'15px'}}
            >
              {supplier.supplier.toUpperCase()}
            </td>
          )}

          {/* INVOICE – once per invoice */}
          {itemIdx === 0 && (
            <td rowSpan={r.items.length}>
              {r.invoiceNo}
              <br />
              DATED
              <br />
              {moment(r.invoiceDate).format("DD.MM.YYYY")}
            </td>
          )}

          {/* AMOUNT – per invoice */}
          {itemIdx === 0 && (
            <td rowSpan={r.items.length} className="fw-bold" style={{fontSize:'16px'}}>{parseFloat(r.amount).toFixed(2)}</td>
          )}

          <td>{item.hsn}</td>
          <td>{item.itemCode}</td>
          <td >{item?.itemName?.toUpperCase()}</td>

          <td>
            {item.primaryQty}
            <br />
            {item.secondaryQty ? `(${item.secondaryQty})` : ""}
          </td>

          <td>
            {item.primaryUom}
            <br />
            {item.secondaryQty ? `(${item.secondaryUom})` : ""}
          </td>

          <td style={{ whiteSpace: "pre-line" }}>
            {item.quality}
          </td>

          {/* PROJECT / MR – per invoice */}
          {itemIdx === 0 && (
            <td rowSpan={r.items.length} style={{ textAlign: "left" }}>
              {r.mrNos?.map((mr, i) => (
                <div key={i} className="fw-bold">{mr}</div>
              ))}

              {r.projects?.map((p, i) => (
                <div key={i} style={{ marginTop: "6px" }}>
                  # PROJECT – {p.projectName}
                  {p.description && <div>{p.description}</div>}
                  {p.centerName && <div>{p.centerName}</div>}
                </div>
              ))}
            </td>
          )}
        </tr>
      ))
    )
  )}
</tbody>

        </table>

        {/* FOOTER */}
        <div className="mt-3">
          <strong>Note :</strong>
          <div style={{ whiteSpace: "pre-line" }}>
            {previewData.noteText}
          </div>

          <strong className="d-block mt-2">Encl:</strong>
          <div className="d-flex justify-content-between">
          <div className="fw-bold">{previewData.enclText}   </div>
          <div className="me-5">Yours affectionately,</div>
          </div>
        </div>

        <div className="text-end mt-4" style={{marginRight:"60px"}}>
          <br />
          <br />
          <strong>(Sanjeev Arora)</strong>
        </div>
        <footer className="footer" style={{
      textAlign: 'center',
      marginTop: '20px',
      fontSize: '14px',
      borderTop: '1px solid black',
      paddingTop: '10px',
      fontWeight: 'bolder',

    }}>
      {footer}
    </footer>
    </div>
  );
};

export default ConfirmationLetterPreview;
